module.exports = __webpack_public_path__ + "img/puzzle_18.93ca4fb5.png";